import React, { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { setLocalItem } from '~/adapters/appStorage';
import { useAppSelector } from '~/behaviors/redux';
import { accountSelectors } from '~/behaviors/selectors/account.selectors';

const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const account = useAppSelector(accountSelectors.selectAccount());
  // @ts-ignore
  const isLoggedIn = account.userId !== null;

  const location = useLocation();
  const { pathname, search, hash } = location;

  if (!isLoggedIn) {
    const url = pathname + search + hash;
    const redirectTo = encodeURIComponent(url);
    const redirectLoginUrl = `/login?redirectTo=${redirectTo}`;

    setLocalItem('redirectTo', url);
    return <Navigate to={redirectLoginUrl} replace />;
  }

  return children;
};

export { ProtectedRoute };
